/**
 * Popup Class
 * 메인 팝업 처리
 */
export class Popup {
    constructor() {
        this.wrap = null;
        this.bg = null;
        this.closeButton = null;
        this.checkbox = null;
        this.swiper = null;
    }

    init() {
        this.wrap = document.querySelector(".main-popup-wrap");
        if (!this.wrap) return;

        this.bg = document.querySelector(".main-popup-bg");
        this.closeButton = document.querySelector(".popup-close");
        this.checkbox = document.getElementById("closeCheck");

        this.initSwiper();
        this.bindEvents();
    }

    initSwiper() {
        // Swiper 인스톨이 전역으로 되어 있어야 함
        if (typeof Swiper !== 'undefined') {
            this.swiper = new Swiper('.main-popup-slide', {
                slidesPerView: 1,
                navigation: {
                    nextEl: '[data-index="next"]',
                    prevEl: '[data-index="prev"]',
                },
                speed: 500,
                spaceBetween: 10,
            });
        }
    }

    bindEvents() {
        this.closeButton?.addEventListener("click", () => this.close());
        this.bg?.addEventListener("click", () => this.close());
        
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") this.close();
        });
    }

    close() {
        if (!this.wrap) return;
        
        this.wrap.style.display = "none";
        
        if (this.checkbox && this.checkbox.checked) {
            const expires = new Date();
            expires.setHours(23, 59, 59, 999); // 오늘 밤 23:59:59까지
            document.cookie = `popupClosed=true; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
        }
    }
}

